import { forwardRef, type ButtonHTMLAttributes } from 'react'

type Variant = 'primary' | 'ghost' | 'outline' | 'danger'
type Size = 'sm' | 'md' | 'lg'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant
  size?: Size
}

const variantClass: Record<Variant, string> = {
  primary:
    'bg-amber-glow text-ink-900 hover:brightness-[1.12] disabled:bg-amber-deep disabled:text-ink-900/70',
  ghost:
    'bg-transparent text-paper border border-transparent hover:border-ink-500 hover:text-amber-glow',
  outline:
    'bg-transparent text-amber-glow border border-amber-glow/50 hover:bg-amber-wash hover:border-amber-glow',
  danger:
    'bg-radar-red/90 text-ink-900 hover:bg-radar-red',
}

const sizeClass: Record<Size, string> = {
  sm: 'text-[11px] px-3 py-1.5 tracking-label',
  md: 'text-[12px] px-4 py-2 tracking-label',
  lg: 'text-[13px] px-5 py-2.5 tracking-label',
}

export const Button = forwardRef<HTMLButtonElement, Props>(function Button(
  { variant = 'primary', size = 'md', className = '', children, ...rest }, ref,
) {
  return (
    <button
      ref={ref}
      className={`
        font-mono uppercase font-medium
        inline-flex items-center gap-2
        transition-colors duration-150
        disabled:cursor-not-allowed
        ${variantClass[variant]} ${sizeClass[size]} ${className}
      `}
      {...rest}
    >
      {children}
    </button>
  )
})
